import { render, staticRenderFns } from "./SmsMessage.vue?vue&type=template&id=e6ae9f0e&scoped=true&"
import script from "./SmsMessage.vue?vue&type=script&lang=js&"
export * from "./SmsMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae9f0e",
  null
  
)

export default component.exports